import Homepage from "./pages/Homepage/Homepage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import Signin from "./pages/signin page/Signin";
//import Contact from "./pages/Contact us/Contact";
import Privacy from "./pages/Privacy/privacy";
import Terms from "./pages/terms/terms";
import ScrollToTop from "./scrolltop";
import NotFound from "./pages/404page/404page";
//import Payment from "./pages/Payment/Payment";
import RefundPage from "./pages/refund/refund";
import Contact from "./pages/Contact us/Contact";
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepage />} />
        {/* <Route path="/signin" element={<Signin />} /> */}
        <Route path="/contact" element={<Contact /> } />
        <Route path="/privacypolicy" element={<Privacy />} />
        <Route path="/terms_condition" element={<Terms />} />
        <Route path="/refund" element={<RefundPage />} />
        {/* <Route path="/user/pay/:amount" element={<Payment />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
